import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import 'chart.js/auto';
import { useState } from 'react';
import { Doughnut, Bar } from 'react-chartjs-2';
import { Button, Row, Col } from 'react-bootstrap';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { FaSortAlphaDown, FaSortAlphaUp } from 'react-icons/fa';
import { FaSortNumericDown, FaSortNumericUp } from 'react-icons/fa';


ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);
// components/Admin/Sondaggi/Risposte/DomandaRisposteGrafico.js
const defaultColors = [
  '#3366CC', '#DC3912', '#FF9900', '#109618', '#990099',
  '#3B3EAC', '#0099C6', '#DD4477', '#66AA00', '#B82E2E',
  '#316395', '#994499', '#22AA99', '#AAAA11', '#6633CC',
  '#E67300', '#8B0707', '#651067', '#329262', '#5574A6',
  '#3B3EAC'
];


export default function DomandaGrafico({ key, domanda, risposte, sezioneEspansa, numeroPartecipanti }) {
  const [tipoGrafico, setTipoGrafico] = useState('doughnut');

  const toggleGrafico = () => {
    setTipoGrafico(tipoGrafico === 'doughnut' ? 'bar' : 'doughnut');
  };

  const [ordineAlfabeticoAsc, setOrdineAlfabeticoAsc] = useState(null);


  const opzioni = domanda?.opzioniRisposte || [];
  const risposteDomanda = risposte?.filter(r => r.domandaId === domanda.domId) || []; // Default a array vuoto
  const totaleRisposte = risposteDomanda.filter(r => r.opzioneRispostaId).length; // Non serve ?.length se abbiamo default a []
  const [ordineTotaleAsc, setOrdineTotaleAsc] = useState(null);

  const numPartecipantiValido = typeof numeroPartecipanti === 'number' ? numeroPartecipanti : 0;
  const saltate = Math.max(0, numPartecipantiValido - totaleRisposte); // Usa Math.max per evitare negativi

  const labels = opzioni.map(o => o.opzRisTesto);
  const counts = opzioni.map(
    o => risposteDomanda?.filter(r => r.opzioneRispostaId === o.opzRisId).length
  );

  // Array unificato con opzione + count
  const opzioniConCount = opzioni?.map((opz) => ({
    ...opz,
    count: risposteDomanda?.filter(r => r.opzioneRispostaId === opz.opzRisId).length
  }));

  const getOpzioniOrdinate = () => {
    let sorted = [...opzioniConCount];

    if (ordineAlfabeticoAsc !== null) {
      sorted.sort((a, b) =>
        a.opzRisTesto.localeCompare(b.opzRisTesto, 'it', { sensitivity: 'base' })
      );
      if (!ordineAlfabeticoAsc) sorted.reverse();
    } else if (ordineTotaleAsc !== null) {
      sorted.sort((a, b) => ordineTotaleAsc ? a.count - b.count : b.count - a.count);
    }

    return sorted;
  };



  const options = {
    responsive: true,

    plugins: {
      legend: {
        display: false
      },

      datalabels: {
        color: '#fff',
        font: {
          weight: 'bold',
          size: 14
        },
        formatter: (value, context) => {
          if (value === 0) {
            return null; // O return '';
          }
          const total = context.chart._metasets[0].total || context.chart._metasets[0].data.reduce((a, b) => a + b, 0);
          const percentage = (value / total * 100).toFixed(1) + '%';
          return percentage;
        }
      }
    }
  };

  // Ottieni l'array ordinato
const opzioniOrdinate = getOpzioniOrdinate();

// Costruisci i dati ordinati per il grafico
const labelsOrdinati = opzioniOrdinate.map(opz => opz.opzRisTesto);
const dataOrdinati = opzioniOrdinate.map(opz => opz.count);
const coloriOrdinati = opzioniOrdinate.map((opz, i) => defaultColors[i]);

const data = {
  labels: labelsOrdinati,
  datasets: [
    {
      label: 'Risposte',
      data: dataOrdinati,
      backgroundColor: coloriOrdinati,
      barThickness: 50,
      borderRadius: 10
    },
  ],
};



  return (
    <div
      className="mb-4 p-3 rounded shadow-sm"
      style={{
        backgroundColor: "#fff",
        border: sezioneEspansa ? "1px solid #000" : "1px solid #dee2e6", // nero o grigino chiaro
        boxShadow: "0 2px 6px rgba(0,0,0,0.1)"
      }}
    >

      <div className="d-flex justify-content-between align-items-center mb-3">
        <div>
          <h5 className="mb-1 fw-bold">D{domanda.domNumPosizione} - {domanda.domDomanda}</h5>
          <small className="text-muted">
            {domanda.tipoDomanda?.tipDomMultipla ? "Scelta multipla" : "Scelta singola"}
          </small>
        </div>
        <Button variant="outline-primary" size="sm" onClick={toggleGrafico}>
          {tipoGrafico === 'doughnut' ? 'Visualizza barre' : 'Visualizza torta'}
        </Button>
      </div>

      <Row>
        <Col
          md={6}
          className="d-flex justify-content-center align-items-center"
          style={{ minHeight: '280px' }} // altezza per centrare la leggenda
        >
          {tipoGrafico === 'doughnut' ? (
            <div style={{ width: "80%", maxWidth: "300px" }} id={`chart-${domanda.domId}`}>

              <Doughnut data={data} options={options} plugins={[ChartDataLabels]} />
            </div>
          ) : (
            <div style={{ width: "90%", height: "300px" }} id={`chart-${domanda.domId}`}> {/* oppure anche 350/400px */}

              <Bar data={data} options={{
                responsive: true,
                  indexAxis: 'y',  

                plugins: {
                  legend: { display: false },
                  datalabels: {
                    color: '#fff', // bianco
                    font: {
                      weight: 'bold',
                      size: 14
                    },
                    formatter: (value, context) => {
                      const dataArr = context.chart.data.datasets[0].data;
                      const total = dataArr.reduce((a, b) => a + b, 0);
                      const percent = total > 0 ? (value / total) * 100 : 0;
                      return percent.toFixed(1) + '%';
                    }
                  }
                },
                scales: {
                  x: {
                    grid: { display: false },
                    ticks: {
                      autoSkip: false,
                      maxRotation: 45,
                      callback: function (value) {
                        const label = this.getLabelForValue(value);
                        return label.length > 20 ? label.slice(0, 20) + '…' : label;
                      }
                    }

                  },

                  y: {

                    beginAtZero: true,
                    ticks: { stepSize: 1 },
                    grid: { display: true } // solo linee orizzontali
                  }
                },
              }} />

            </div>
          )}
        </Col>

        <Col md={6} className="d-flex flex-column justify-content-center">
          <Row className="px-3 mb-2">
            <Col className="d-flex align-items-center gap-2">
              <strong className="text-muted  small mb-0">Scelte</strong>
              <Button
                variant="link"
                className="p-0 m-0"
                style={{ fontSize: "0.9rem" }}
                onClick={() => {
                  setOrdineAlfabeticoAsc((prev) => {
                    if (prev === null) {
                      setOrdineTotaleAsc(null); // resetta l'altro
                      return true;
                    }
                    if (prev === true) return false;
                    return null;
                  });
                }}

              >
                {ordineAlfabeticoAsc === null ? <FaSortAlphaDown color="black" /> :
                  ordineAlfabeticoAsc ? <FaSortAlphaUp color="black" /> : <FaSortAlphaDown color="black" />}
              </Button>
            </Col>
            <Col className="d-flex align-items-center gap-2 justify-content-end">
              <strong className="text-muted  small mb-0">Totale</strong>
              <Button
                variant="link"
                className="p-0 m-0"
                style={{ fontSize: "0.9rem" }}
                onClick={() => {
                  setOrdineTotaleAsc((prev) => {
                    if (prev === null) {
                      setOrdineAlfabeticoAsc(null); // resetta l'altro
                      return true;
                    }
                    if (prev === true) return false;
                    return null;
                  });
                }}

              >
                {ordineTotaleAsc === null ? <FaSortNumericDown color="black" /> :
                  ordineTotaleAsc ? <FaSortNumericUp color="black" /> : <FaSortNumericDown color="black" />}
              </Button>
            </Col>

          </Row>
          <hr className="mt-0 mb-2" style={{ borderTop: "1px solid #ccc" }} />
          <ul className="list-unstyled">
            {getOpzioniOrdinate().map((opz, i) => (
              <li key={opz.opzRisId} className="d-flex justify-content-between align-items-center mb-2">
                <div className="d-flex align-items-center">
                  <div
                    style={{
                      width: 14,
                      height: 14,
                      borderRadius: "50%",
                      backgroundColor: data.datasets[0].backgroundColor?.[i] || `#ccc`,
                      marginRight: 10
                    }}
                  ></div>
                  <span>{opz.opzRisTesto}</span>
                </div>
                <strong>{opz.count}</strong>
              </li>
            ))}

          </ul>

          <div className="mt-3 pt-2 border-top text-center">
            <p className="small text-muted mb-0">
              <strong>Risposte date:</strong> {totaleRisposte} &nbsp;&nbsp; | &nbsp;&nbsp;
              <strong>Saltate:</strong> {saltate}
            </p>
          </div>
        </Col>

      </Row>

    </div>
  );
}
